import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import FitGapBoard from './pages/fit-gap-board';
import PricingPlans from './pages/pricing-plans';
import DocumentGenerator from './pages/document-generator';
import MarketingHome from './pages/marketing-home';
import QuestionnaireRunner from './pages/questionnaire-runner';
import DigitalSignoffs from './pages/digital-signoffs';
import UserRegistration from './pages/user-registration';
import AppDashboard from './pages/app-dashboard';
import BestPracticePicker from './pages/best-practice-picker';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MarketingHome />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/fit-gap-board" element={<FitGapBoard />} />
        <Route path="/pricing-plans" element={<PricingPlans />} />
        <Route path="/document-generator" element={<DocumentGenerator />} />
        <Route path="/marketing-home" element={<MarketingHome />} />
        <Route path="/questionnaire-runner" element={<QuestionnaireRunner />} />
        <Route path="/digital-signoffs" element={<DigitalSignoffs />} />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/app-dashboard" element={<AppDashboard />} />
        <Route path="/best-practice-picker" element={<BestPracticePicker />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
